import { Trans } from '@lingui/react/macro';

import { ArticleWithRelations } from '@/models/request';

import { BaseMessage } from './BaseMessage';

export const QualityControlTaskMessage = ({ article }: { article: ArticleWithRelations }) => {
  return (
    <>
      <BaseMessage
        title={<Trans id="article.task.quality-control.title">Proceed to quality control</Trans>}
        message={
          <Trans id="article.task.quality-control.message">
            Please inspect the item and complete the quality control form.
          </Trans>
        }
        article={article}
      />
    </>
  );
};
